import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { VerifyService } from 'src/app/services/verify/verify.service';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { AlertListService } from '@xref/ngx';
import { EditDialogService } from 'src/app/services/edit-dialog/edit-dialog.service';

@Component({
    selector: 'xqnr-verify-email-form',
    templateUrl: './verify-email-form.component.pug',
    styleUrls: ['./verify-email-form.component.scss'],
    standalone: false
})
export class VerifyEmailFormComponent implements OnInit {
  @Input() submitActionLabelKey = '';
  @Output() emailFormSubmit = new EventEmitter();

  showDialog = false;
  emailReqLoading = false;

  emailValidPattern = new RegExp(/.+@.+\..{2,}/);

  emailForm = this.fb.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    emailAddress: ['', Validators.pattern(this.emailValidPattern)]
  });

  fa = {
    circleNotch: faCircleNotch
  };

  constructor(
    private fb: FormBuilder,
    public verify: VerifyService,
    private alertList: AlertListService,
    private editDialog: EditDialogService
  ) {}

  ngOnInit() {
    // Clear error alerts if the edit dialog is closed
    this.editDialog.active$.subscribe((active) => {
      if (!active) this.resetErrorAlerts();
    });
  }

  resetErrorAlerts() {
    this.verify.emailError.generic = false;
    this.verify.emailError.whitelist = false;
  }

  submitEmailSuccess = () => {
    this.emailReqLoading = false;
    this.verify.submittedEmail = this.emailForm.controls.emailAddress.value;
    this.emailFormSubmit.emit();
    this.alertList.clear(); // Most likely the "session expired" alert
  };

  submitEmailError = (err: any) => {
    this.emailReqLoading = false;

    if (err.error.email && err.error.email[0] == 'Cannot use free email provider domain.')
      this.verify.emailError.whitelist = true;
    else
      this.verify.emailError.generic = true;
  };

  submitEmail() {
    if (this.emailForm.valid) {
      const data = {
        email: this.emailForm.controls.emailAddress.value,
        first_name: this.emailForm.controls.firstName.value,
        last_name: this.emailForm.controls.lastName.value
      };

      this.resetErrorAlerts();

      this.emailReqLoading = true;

      this.verify.verifyEmail(data).subscribe(this.submitEmailSuccess, this.submitEmailError);
    }
  }
}
